import assets from './imageAssets.json';
export function imageProps(key, sizes) {
    const image = assets[key];
    const variants = image.variants;
    return {
        src: variants[variants.length - 1].url,
        srcSet: variants.length > 1 ? variants.map(v => v.url + ' ' + v.width + 'w').join(', ') : undefined,
        sizes,
        width: image.width,
        height: image.height,
        decoding: 'async',
    };
}
export const heroSizes = '(max-width: 576px) 160px, (max-width: 991px) 304px, 480px';
